import RecentSolicitationsGrid from './RecentSolicitationsGrid'

export default RecentSolicitationsGrid


// WEBPACK FOOTER //
// ./src/components/grids/RecentSolicitations/index.jsx